import { colors, fontSizes, Icon, iconSizes } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledCategory = styled.div``

export const EditButton = styled.div`
  visibility: hidden;
  cursor: pointer;

  :hover {
    color: ${colors.textDarkest};
  }
`

export const Title = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 0.5rem;

  :hover {
    ${EditButton} {
      visibility: visible;
    }
  }
`

export const Name = styled.div`
  font-family: "IBM Plex Sans", Arial, Helvetica, sans-serif;
  font-weight: 700;
  font-size: ${fontSizes._24};
  cursor: pointer;
`

export const Description = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;

  line-height: 1.3;
  margin-bottom: 1.5rem;
`

export const EditIcon = styled(Icon).attrs({ code: "edit", size: iconSizes._20 })`
  padding: 0 0.75rem;
  position: relative;
  top: 0.2rem;
`
